import { IconInfoCircle } from "@tabler/icons-react";

import { colors } from "#app/theme/v1/colors";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { Flex } from "#shared/view/components/Flex";
import { Popover } from "#shared/view/components/Popover";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

export const InfoPredictedPricePopover = () => {
  return (
    <Popover
      width={350}
      position="top"
      withArrow
      shadow="md"
      radius={"md"}
      styles={{
        dropdown: {
          backgroundColor: colors.violet[0],
        },
      }}
    >
      <Popover.Target>
        <ActionIcon color={"violet.5"} size={"sm"}>
          <Icon name="infoCircle" size={14} />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap={"xs"}>
          <Flex gap={"xs"} align={"center"}>
            <IconInfoCircle size={14} />
            <Text size="xs">Comment nous prédisons les coûts :</Text>
          </Flex>

          <Text size="xs">
            Les coûts sont prédits par notre modèle d’intelligence artificielle qui tire parti des
            données de votre historique. Nous vous présentons le coût prédit ainsi que la précision
            atteinte par notre algorithme.
          </Text>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};
